import { InsurancesPage } from "./InsurancesPage";
export default InsurancesPage;
